'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalHeader = require('./ModalHeader');

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _ModalSection = require('./ModalSection');

var _ModalSection2 = _interopRequireDefault(_ModalSection);

var _reactTransitionGroup = require('react-transition-group');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TRANSITION_TIME = 250;

var Modal = function (_PureComponent) {
  _inherits(Modal, _PureComponent);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.getClassName = function () {
      var _this$props = _this.props,
          isOpen = _this$props.isOpen,
          className = _this$props.className;

      var classes = 'Modal ' + className;

      if (isOpen) {
        classes += ' is-open';
      }
      return classes;
    }, _this.handleInteriorClick = function (event) {
      event.stopPropagation(); // Don't want it to bubble up to the background.
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        if (this.props.isOpen) {
          document.querySelector('body').classList.add('modal-open');
        } else {
          document.querySelector('body').classList.remove('modal-open');
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpen = _props.isOpen,
          closeModal = _props.closeModal;

      return _react2.default.createElement(
        _reactTransitionGroup.CSSTransitionGroup,
        {
          transitionName: 'fade-in',
          transitionEnterTimeout: TRANSITION_TIME,
          transitionLeaveTimeout: TRANSITION_TIME
        },
        isOpen && _react2.default.createElement(
          'div',
          { className: this.getClassName(), onClick: closeModal },
          _react2.default.createElement('div', { className: 'Modal-background' }),
          _react2.default.createElement(
            'div',
            { className: 'Modal-dialog-wrapper' },
            _react2.default.createElement(
              'div',
              { className: 'Modal-dialog', onClick: this.handleInteriorClick },
              this.props.children
            )
          )
        )
      );
    }
  }]);

  return Modal;
}(_react.PureComponent);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  closeModal: _propTypes2.default.func.isRequired
};

Modal.defaultProps = {
  isOpen: false,
  className: ''
};

Modal.Header = _ModalHeader2.default;
Modal.Section = _ModalSection2.default;
exports.default = Modal;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/Modal/index.js
// module id = 591
// module chunks = 0